var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinsRewards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 42,
    viewBox: "0 0 72 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2063_208872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1992 20.873H3.58407V10.8115H47.1992V20.873Z",
    fill: "#FFCF2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5625 10.5234H47.2539V10.9866H3.5625V10.5234Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50781 20.5215H47.1992V20.9846H3.50781V20.5215Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6914 10.7559H43.1581V20.8654H42.6914V10.7559Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9922 10.7559H34.4589V20.8654H33.9922V10.7559Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6133 10.8672H25.08V20.9767H24.6133V10.8672Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6914 10.8672H16.1581V20.9767H15.6914V10.8672Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33594 10.8672H7.80262V20.9767H7.33594V10.8672Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0664 31.0293H8.37501V20.8081H52.0664V31.0293Z",
    fill: "#FFCF2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 20.5215H52.1211V20.9846H8.42969V20.5215Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.375 30.5176H52.0664V30.9807H8.375V30.5176Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5586 20.752H48.0253V30.8615H47.5586V20.752Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8594 20.752H39.3261V30.8615H38.8594V20.752Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4805 20.8652H29.9472V30.9748H29.4805V20.8652Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5586 20.8652H21.0253V30.9748H20.5586V20.8652Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2031 20.8652H12.6698V30.9748H12.2031V20.8652Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6914 40.8535H0.0515022V30.8043H43.6914V40.8535Z",
    fill: "#FFCF2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0546875 30.5156H43.7461V30.9788H0.0546875V30.5156Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 40.5137H43.6914V40.9768H0V40.5137Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1836 30.748H39.6503V40.8576H39.1836V30.748Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4844 30.748H30.9511V40.8576H30.4844V30.748Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1055 30.8613H21.5722V40.9708H21.1055V30.8613Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1797 30.8613H12.6464V40.9708H12.1797V30.8613Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82812 30.8613H4.29481V40.9708H3.82812V30.8613Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2491 10.6573C38.2011 10.3872 39.5913 10.6715 40.3441 10.882C48.1714 13.0697 42.7298 32.1444 52.4014 39.0718C53.9727 40.1973 55.5115 40.7263 56.415 40.9812C52.1576 40.9812 47.9002 40.9812 43.6428 40.9811C41.6256 38.1231 38.8016 33.3818 37.1592 26.9423C35.402 20.0529 35.7578 14.2008 36.2491 10.6573Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3146 19.3466L38.4321 19.876C38.9888 22.2854 39.8591 24.8091 41.0479 27.3295C41.0626 27.3629 41.0784 27.3954 41.0941 27.4288C41.1542 27.5552 41.2153 27.6817 41.2765 27.8071C42.4476 30.2103 43.8063 32.3865 45.2663 34.2731C45.3779 34.4185 45.4907 34.5608 45.6047 34.7021C47.5086 37.0792 49.5733 38.9655 51.6164 40.2222C51.7883 40.3287 51.9584 40.4287 52.1287 40.5246C52.1307 40.5267 52.1339 40.5279 52.1359 40.5291C52.1474 40.5359 52.1589 40.5427 52.1704 40.5495C54.8237 42.0361 57.413 42.4358 59.536 41.443L64.7642 38.9982L65.8203 38.5047L67.7387 37.6077C73.0681 35.1171 73.4507 24.8037 68.5937 14.5716C63.7376 4.34087 55.48 -1.93418 50.1517 0.557566L48.2366 1.45152L48.2355 1.45257L48.2354 1.45363L47.1794 1.94704L47.1782 1.9481L41.949 4.39174C39.8248 5.38557 38.4871 7.62016 37.9536 10.5969C37.9154 10.8042 37.8823 11.0149 37.8534 11.23C37.5285 13.5939 37.6802 16.3753 38.3146 19.3466Z",
    fill: "#FFCF2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2294 8.74394C45.1212 10.951 45.3486 13.34 45.8892 15.8028C45.927 15.9792 45.9679 16.1558 46.0099 16.3324C46.5892 18.7873 47.4747 21.3052 48.642 23.7782C48.6567 23.8116 48.6724 23.844 48.6882 23.8775C48.7482 24.0039 48.8094 24.1304 48.8706 24.2558C50.0199 26.6157 51.3655 28.7988 52.8451 30.7297C52.9547 30.874 53.0664 31.0173 53.1792 31.1595C54.7486 33.1407 56.4599 34.8379 58.2439 36.1597C58.5188 36.3636 58.793 36.5568 59.0667 36.7383C59.2424 36.8566 59.4184 36.9697 59.5935 37.0783C61.3881 38.1906 63.1364 38.8367 64.7633 38.9978L65.8194 38.5044C65.6385 38.511 65.4581 38.5102 65.2746 38.5029C59.9622 38.2919 53.3178 32.3863 49.1706 23.6507C44.8817 14.6148 44.6472 5.45886 48.2345 1.45312L47.1784 1.94654L47.1773 1.9476C46.2663 3.29484 45.6541 5.04412 45.3758 7.12676C45.3483 7.33026 45.324 7.53602 45.3037 7.7462C45.2704 8.07129 45.2463 8.40427 45.2294 8.74394Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9375 27.377L48.8566 23.6743L49.084 24.1533L41.1649 27.856L40.9375 27.377Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6172 40.2228L59.0686 36.7393L59.4638 36.5547L59.6913 37.0344L59.5954 37.0794L52.1713 40.5501L51.6172 40.2228Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2656 34.2725C45.3772 34.4179 45.4901 34.5602 45.604 34.7015L53.1795 31.1594L53.2558 31.1232L53.0273 30.6445L52.8454 30.7295L45.2656 34.2725Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9518 10.5967L45.3749 7.12697L45.4707 7.08203L45.6982 7.5617L45.3029 7.74641L37.8516 11.2298L37.9518 10.5967Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3125 19.3459L45.888 15.8027L45.9643 15.7676L46.1917 16.2473L46.0088 16.3323L38.43 19.8753L38.3125 19.3459Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8479 9.87304C47.8693 13.7147 49.0441 18.2784 51.1541 22.7256C53.2651 27.1718 56.0643 30.9773 59.0351 33.4392C61.1314 35.1762 63.1482 36.1055 64.909 36.1753C65.6887 36.2063 66.4185 36.0689 67.0837 35.7581C69.2481 34.7458 70.4278 32.0342 70.406 28.1226C70.3857 24.282 69.2109 19.7173 67.0999 15.2701C64.9889 10.8239 62.1907 7.01833 59.2199 4.55755C56.1943 2.0501 53.3358 1.22634 51.1714 2.2376C49.0069 3.24998 47.8272 5.96153 47.8479 9.87304ZM51.3987 2.71734C51.9856 2.44275 52.6336 2.32116 53.33 2.34874C54.9682 2.41374 56.8733 3.30251 58.8776 4.96372C61.7906 7.37664 64.539 11.1177 66.6174 15.4968C68.696 19.8749 69.8515 24.3594 69.8728 28.1258C69.8927 31.8189 68.8214 34.3599 66.8562 35.2783C64.8899 36.1978 62.2334 35.4001 59.3763 33.0318C56.4643 30.6189 53.716 26.8779 51.6375 22.4998C49.559 18.1207 48.4024 13.636 48.3822 9.87086C48.3612 6.17668 49.4336 3.63579 51.3987 2.71734Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3882 30.7894C60.313 30.8787 60.1841 30.911 60.0724 30.8602C59.9384 30.7992 59.8795 30.6421 59.9408 30.5091C62.1299 25.7658 64.1137 20.9723 62.2808 19.0299C61.0515 17.7272 59.776 18.3697 58.4257 19.0498C57.1975 19.6684 55.9276 20.308 54.856 19.1725C53.4977 17.7329 52.9342 14.3882 57.9637 6.62959C58.0429 6.50575 58.2085 6.47103 58.3325 6.55016C58.4564 6.62929 58.4922 6.79312 58.4125 6.91613C54.6336 12.7457 53.5089 16.9699 55.2456 18.8105C56.0047 19.615 56.8568 19.246 58.1841 18.5775C59.5131 17.9081 61.1672 17.075 62.6704 18.6679C64.729 20.8498 62.6905 25.8229 60.4261 30.7297C60.4158 30.7516 60.4031 30.7716 60.3882 30.7894Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6951 11.3179C55.6721 11.3453 55.643 11.3685 55.6086 11.3853C55.4767 11.4502 55.3165 11.3966 55.2511 11.2654L53.4107 7.5757C53.3452 7.44457 53.399 7.28548 53.5315 7.22093C53.6635 7.156 53.8235 7.20966 53.889 7.34079L55.7294 11.0305C55.7779 11.1276 55.7608 11.2399 55.6951 11.3179Z",
    fill: "#2D3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4812 30.5894C64.4577 30.6172 64.4282 30.6405 64.3933 30.6575C64.2607 30.7216 64.1011 30.667 64.0365 30.5356L62.0895 26.5704C62.0249 26.4387 62.0802 26.2803 62.2124 26.2163C62.345 26.1522 62.5047 26.2068 62.5692 26.3383L64.5162 30.3034C64.5638 30.4002 64.5465 30.5117 64.4812 30.5894Z",
    fill: "#2D3281"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2063_208872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsRewards);
export default __webpack_public_path__ + "static/media/coinsRewards.37a482d0b2c76596356dc86bb8c53701.svg";
export { ForwardRef as ReactComponent };